import * as u from "lucide-react";
import { jsx as p } from "react/jsx-runtime";
import { Text as v } from "@telegraph/typography";
import d from "clsx";
const g = {
  0: "0.8125rem",
  1: "0.874rem",
  2: "var(--tgph-spacing-4)",
  3: "1.125rem",
  4: "var(--tgph-spacing-5)",
  5: "1.375rem",
  6: "1.625rem",
  7: "var(--tgph-spacing-8)",
  8: "var(--tgph-spacing-9)",
  9: "var(--tgph-spacing-12)"
}, s = {
  primary: {
    default: "var(--tgph-gray-12)",
    gray: "var(--tgph-gray-11)",
    accent: "var(--tgph-accent-11)",
    beige: "var(--tgph-beige-11)",
    blue: "var(--tgph-blue-11)",
    green: "var(--tgph-green-11)",
    yellow: "var(--tgph-yellow-11)",
    purple: "var(--tgph-purple-11)",
    red: "var(--tgph-red-11)",
    white: "var(--tgph-white)",
    disabled: "var(--tgph-gray-9)",
    black: "var(--tgph-black)"
  },
  secondary: {
    default: "var(--tgph-gray-11)",
    gray: "var(--tgph-gray-10)",
    accent: "var(--tgph-accent-10)",
    beige: "var(--tgph-beige-10)",
    blue: "var(--tgph-blue-10)",
    green: "var(--tgph-green-10)",
    yellow: "var(--tgph-yellow-10)",
    purple: "var(--tgph-purple-10)",
    red: "var(--tgph-red-10)",
    white: "var(--tgph-white)",
    disabled: "var(--tgph-gray-8)",
    black: "var(--tgph-black)"
  }
}, w = ({
  as: h,
  size: e = "2",
  color: i = "default",
  variant: c = "primary",
  icon: l,
  alt: a,
  className: o,
  style: n,
  ...t
}) => {
  const r = l;
  if (!r)
    throw new Error("@telegraph/icon: icon prop is required");
  if (!a && !t["aria-hidden"])
    throw new Error("@telegraph/icon: alt prop is required");
  return /* @__PURE__ */ p(
    v,
    {
      as: h || "span",
      className: d("tgph-icon", o),
      "data-button-icon": !0,
      style: {
        // We choose to override these values vs passing them in as props because
        // the icon's sizes aren't all exact telegraph tokens and the colors
        // of the icon are different than the text color. Because of how the Text
        // component is setup this is a valid way to inject these values in for these
        // few cases.
        "--height": g[e],
        "--width": g[e],
        "--color": s[c][i],
        ...n
      },
      ...t,
      children: r && /* @__PURE__ */ p(
        r,
        {
          "aria-label": a,
          width: "100%",
          height: "100%",
          display: "block"
        }
      )
    }
  );
};
export {
  w as Icon,
  u as Lucide
};
//# sourceMappingURL=index.mjs.map
